import API from '../../../../../services/api';

export const COMERCIALES_API = {
    get: async (page = 1, search = null) => {
        return await API.get(`/detalle-comercial?page=${page}${search || ''}`).then(res => res.data);
    },
    nextContact: async (contacto) => {
        return API.post('/detalle-comercial/'+ contacto.entity_id +'/proximo-contacto', contacto).then(res => res.data);
    },
    pasarAInteresados: async (detalleId, data) => {
        return API.post('/detalle-comercial/' + detalleId + '/pasar-interesados', data).then(res => res.data);
    },
    updateObservaciones: async (observaciones) => {
        return API.post('/detalle-comercial/'+ observaciones.entity_id +'/observaciones', observaciones).then(res => res.data);
    },
    newContact: async (entityId, contacto) => {
        return API.post('/detalle-comercial/' + entityId + '/contacto', contacto).then(res => res.data);
    },
    exportEntitiesLastSells: async () => {
        return API.post('/detalle-comercial/export/detalles', null, {responseType: 'blob'}).then(res => res.data);
    },
    exportConversion: async (filters) => {
        return API.post('/detalle-comercial/export/conversion', filters, {responseType: 'blob'}).then(res => res.data);
    },
    checkPhones: async (data) => {
        return API.post('/detalle-comercial/export/comprobar', data, {responseType: 'blob'}).then(res => res.data);
    },
    update: async (detalle) => {
        return API.put('/detalle-comercial/'+ detalle.id, detalle).then(res => res.data);
    },
    updateContact: async (contacto) => {
        return API.put('/detalle-comercial/'+ contacto.id +'/update-contacto', contacto).then(res => res.data);
    },
    delete: async (detalle) => {
        return API.delete('/detalle-comercial/'+ detalle.id).then(res => res.data);
    },
}